import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import EditSalesInvoice from '../../components/Sales/editSalesInvoice';
import { printSalesInvoice } from '../../actions/print_actions';
import { fetchInventories } from '../../actions/inventories_actions';
import { fetchSalesInvoiceDetail, updateSalesInvoice, resetFormInputs, updateInvoiceEmployeeNote } from '../../actions/salesInvoice_actions';
import { fetchCustomerPrices, fetchTaxRates, setSaleRowValue, setValue, fetchSalesOrderLineWeights, setOrderLineWeights } from '../../actions/sales_actions';


let editSalesInvoice = reduxForm({
  form: 'editSalesInvoice',
})(EditSalesInvoice);

editSalesInvoice = connect(state => ({
  initialValues: state.salesInvoice.currentSalesInvoice,
}))(editSalesInvoice);

const selector = formValueSelector('editSalesInvoice');

function mapStateToProps(state) {
  const DocumentDate = selector(state, 'DocDate');
  const OrderDate = selector(state, 'OrderDate');
  const NewItem = selector(state, 'NewItem');
  const Quantity = selector(state, 'Quantity');
  const UnitPrice = selector(state, 'UnitPrice');
  const searchValue = selector(state, 'ProductInformation');
  const searchType = selector(state, 'searchType');
  const ItemNotation = selector(state, 'itemNotation');
  const Notation = selector(state, 'Notation');
  const postingDate = selector(state, 'PostingDate');
  const invoiceNum = selector(state, 'InvoiceNum');
  const CreateTime = selector(state, 'CreateTime');
  const InvoiceShipDate = selector(state, 'InvoiceShipDate');

  return {
    DocumentDate,
    OrderDate,
    NewItem,
    Quantity,
    UnitPrice,
    searchValue,
    searchType,
    ItemNotation,
    Notation,
    postingDate,
    invoiceNum,
    CreateTime,
    InvoiceShipDate,

    inventories: state.inventories.all,
    inventoriesIsLoading: state.inventories.isLoading,
    inventoriesError: state.inventories.error,
    currentSalesInvoice: state.salesInvoice.currentSalesInvoice,
    salesInvoiceDetail: state.salesInvoice.currentSalesInvoiceDetail,
    detailIsLoading: state.salesInvoice.detailIsLoading,
    detailError: state.salesInvoice.detailError,
    userPermissions: state.auth.userPermissions,

    customerPrices: state.salesOrders.customerPrices,
    customerPricesIsLoading: state.salesOrders.customerPricesIsLoading,
    customerPricesError: state.salesOrders.customerPricesError,

    taxRates: state.salesOrders.taxRates,
    taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
    taxRatesError: state.salesOrders.taxRatesError,

    salesInvoiceIsUpdating: state.salesInvoice.salesInvoiceIsUpdating,
    salesInvoiceUpdateError: state.salesInvoice.salesInvoiceUpdateError,
    salesInvoiceUpdated: state.salesInvoice.salesInvoiceUpdated,

    siCustomerIsEditing: state.salesInvoice.siCustomerIsEditing,
    siCustomerEdited: state.salesInvoice.siCustomerEdited,

    salesOrderProduct: state.salesOrders.salesOrderProduct,
    salesOrderProductIsLoading: state.salesOrders.salesOrderProductIsLoading,
    salesOrderProductFailure: state.salesOrders.salesOrderProductFailure,

    salesInvoicePdf: state.print.salesInvoicePdf,
    salesInvoicePdfError: state.print.salesInvoicePdfError,
    printSalesInvoiceIsLoading: state.print.printSalesInvoiceIsLoading,
  };
}

export default connect(mapStateToProps, {
  updateSalesInvoice,
  fetchInventories,
  fetchSalesInvoiceDetail,
  fetchCustomerPrices,
  fetchTaxRates,
  setSaleRowValue,
  setValue,
  resetFormInputs,
  fetchSalesOrderLineWeights,
  setOrderLineWeights,
  printSalesInvoice,
  updateInvoiceEmployeeNote,
})(editSalesInvoice);



// WEBPACK FOOTER //
// ./master/jsx/containers/Sales/editSalesInvoice.jsx